import { render } from "./UploadPicture.vue?vue&type=template&id=16395b34&scoped=true&ts=true"
import script from "./UploadPicture.vue?vue&type=script&lang=ts"
export * from "./UploadPicture.vue?vue&type=script&lang=ts"

import "./UploadPicture.vue?vue&type=style&index=0&id=16395b34&lang=scss&scoped=true"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16395b34"]])

export default __exports__